<div [hidden]="hidden" class="input" [ngClass]="{ 'input--inline': inline}">
  <div [formGroup]="field.formGroup ? formGroup : form">
    <label *ngIf="field.label && !field.hideLabel && field.controlType !== 'switch'">{{ field.label }}</label>
    <ng-container [ngSwitch]="field.controlType">
      <swb-dropdown *ngSwitchCase="'dropdown'" [control]="control" [field]="field"></swb-dropdown>
      <swb-textarea *ngSwitchCase="'textarea'" [control]="control" [field]="field"></swb-textarea>
      <swb-switch *ngSwitchCase="'switch'" [control]="control" [field]="field"></swb-switch>
      <swb-tags *ngSwitchCase="'tags'" [formControl]="control" [field]="field"></swb-tags>
      <swb-contained *ngSwitchCase="'contained'" [formControl]="control" [field]="field"></swb-contained>
      <swb-contained-many *ngSwitchCase="'containedMany'" [formControl]="control" [field]="field"></swb-contained-many>
      <swb-contained-fields *ngSwitchCase="'containedFormFields'" [formControl]="control" [field]="field" [lang]="lang">
      </swb-contained-fields>
      <swb-radiuses-editor *ngSwitchCase="'radiuses'" [formControl]="control" [field]="field"></swb-radiuses-editor>
      <input *ngSwitchCase="'hidden'" type="hidden" [formControl]="control" />
      <div class="input__row" *ngSwitchCase="'fields-row'">
        <swb-form-field *ngFor="let fld of field.fields" [form]="form" [field]="fld" [inline]="true"></swb-form-field>
      </div>
      <swb-datetimepicker *ngSwitchCase="'datetimepicker'" [formControl]="control" [field]="field"></swb-datetimepicker>
      <swb-datepicker *ngSwitchCase="'datepicker'" [formControl]="control" [field]="field"></swb-datepicker>
      <swb-timepicker *ngSwitchCase="'timepicker'" [control]="control" [field]="field"></swb-timepicker>
      <swb-svglist *ngSwitchCase="'svglist'" [formControl]="control" [field]="field"></swb-svglist>
      <swb-parameters *ngSwitchCase="'parameters'" [formControl]="control" [field]="field"></swb-parameters>
      <swb-textbox *ngSwitchDefault [control]="control" [field]="field"></swb-textbox>
    </ng-container>
  </div>
</div>